import RandingStyle7 from "../../randing/RandingStyle7";

function Randing224({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle7
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/224/1.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/224/2.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/224/3.png`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/224/4.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/224/5.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      qOptionImgPath={`${process.env.REACT_APP_CDN_BASE}/images/224`} // 필수!
      qOptions={["벌어진 앞니", "튀어나온 덧니", "돌출입", "치열개선"]}
      formFieldColor="white"
      colorRequest="white"
      companyName="검단뉴욕치과"
      privacyCompanyName="검단뉴욕치과의원"
      addStyle={{ marginTop: 0, width: "117.5%" }}
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/geomdan.png`}
      kakaotalk="003"
      carrotTag={true}
    />
  );
}

export default Randing224;
